import { render, staticRenderFns } from "./MyCertificate.vue?vue&type=template&id=71ba8bb2&scoped=true&"
import script from "./MyCertificate.vue?vue&type=script&lang=js&"
export * from "./MyCertificate.vue?vue&type=script&lang=js&"
import style0 from "../../components/common/css/MainCertificate.css?vue&type=style&index=0&id=71ba8bb2&scoped=true&lang=css&"
import style1 from "./MyCertificate.vue?vue&type=style&index=1&id=71ba8bb2&scoped=true&lang=css&"
import style2 from "./MyCertificate.vue?vue&type=style&index=2&id=71ba8bb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ba8bb2",
  null
  
)

export default component.exports